/**
 * What a new query inherits from the one it replaces. A sort, a view and a page
 * size say how results are shown rather than which ones, and a vehicle is a
 * standing choice with a card of its own — the rest of the URL describes the
 * search being left behind. A ride type is one of those: ticking Dirt Bikes on
 * a boot search says which boots, not what every later search is for.
 */
const CARRIED_PARAMS = ['sort', 'view', 'limit', 'bikes'];

/** Zero-width and bidi characters a paste carries in. */
const INVISIBLE = /[​-‏‪-‮⁠-⁯﻿]/g;

/**
 * The URL a freshly typed query starts from. The previous search's filters are
 * dropped rather than added to: a query says what the shopper is after now, and
 * one that inherits a category, a size or a brand is answering a question they
 * only asked once.
 */
export function newSearchHref(
  keyword: string,
  current: URLSearchParams
): string {
  const params = new URLSearchParams();
  params.set('keyword', keyword.trim().replace(INVISIBLE, ''));

  for (const key of CARRIED_PARAMS) {
    const value = current.get(key);
    if (value) params.set(key, value);
  }

  return `/search?${params.toString()}`;
}
